<template>
    <div class="lawsuit-programme">
        <Row class="detail-header">
            <span>庭前准备</span>
            <ButtonGroup size="small" class="lawsuit-btn">
                <Button @click="tabActive='summons'" :type="tabActive=='summons'?'primary':'default'">传票</Button>
                <Button @click="tabActive='preservation'" :disabled="disabledCtrl" :type="tabActive=='preservation'?'primary':'default'">保全</Button>
                <Button @click="tabActive='serviceOfNotice'" :disabled="disabledCtrl" :type="tabActive=='serviceOfNotice'?'primary':'default'">公告送达</Button>
                <Button @click="tabActive='evidenceExchange'" :disabled="disabledCtrl" :type="tabActive=='evidenceExchange'?'primary':'default'">证据交换</Button>
                <Button @click="tabActive='jurisdictionalProtest'" :disabled="disabledCtrl && (!caseTrialState)" :type="tabActive=='jurisdictionalProtest'?'primary':'default'">管辖异议</Button>
                <Button @click="tabActive='originalApply'" :disabled="disabledCtrl" :type="tabActive=='originalApply'?'primary':'default'">原件申请</Button>
            </ButtonGroup>
        </Row>
        <Row class="lawsuit-form">
            <summons v-bind="$attrs" v-if="tabActive=='summons'" :caseState="caseState" :prevCode="prevCode" :processId="processId" :caseId="caseId" @getAuditState="getState" v-on="$listeners"></summons>
            <preservation v-bind="$attrs" v-if="tabActive=='preservation'" :processId="processId" :caseId="caseId" v-on="$listeners"></preservation>
            <serviceOfNotice v-bind="$attrs" v-if="tabActive=='serviceOfNotice'" :caseState="caseState" :processId="processId" :caseId="caseId" v-on="$listeners"></serviceOfNotice>
            <evidenceExchange v-bind="$attrs" v-if="tabActive=='evidenceExchange'" :processId="processId" :caseId="caseId" v-on="$listeners"></evidenceExchange>
            <jurisdictionalProtest v-bind="$attrs" v-if="tabActive=='jurisdictionalProtest'" 
                :processId="processId" :caseId="caseId" :caseTrialState="caseTrialState" v-on="$listeners"></jurisdictionalProtest>
            <!-- 原件申请 -->
            <originalApply v-bind="$attrs" v-if="tabActive=='originalApply'" :processId="processId" :projectId="projectId" :caseId="caseId"></originalApply>
        </Row>
    </div>
</template>
<script>
import summons from './summons.vue';
import preservation from './preservation.vue';
import serviceOfNotice from './serviceOfNotice.vue';
import evidenceExchange from './evidenceExchange.vue';
import jurisdictionalProtest from './jurisdictionalProtest.vue';
import originalApply from './originalApply.vue';
export default {
    inheritAttrs:false,
    data () {
        return {
            tabActive:'summons',
            disabledCtrl:true,
        }
    },
    props: ['processId','caseId','caseTrialState','prevCode','projectId','caseState'],
    methods: {
        getState(state){
            this.disabledCtrl = !state;
        }
    },
    created(){},
    beforeMount(){},
    mounted(){},
    updated(){},
    components: {
        summons,
        preservation,
        serviceOfNotice,
        evidenceExchange,
        jurisdictionalProtest,
        originalApply
    },
    watch: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
@import '../caseCommon.scss';
.lawsuit-programme{
    .lawsuit-form{
        margin-top:10px;
        padding-top:10px;
        border-top:1px solid $borderColor;
    }
 }
</style>



// WEBPACK FOOTER //
// src/view/civilCase/pretrial/index.vue